export const MONTHLY_PAYROLL_DATA = `
  id
  month
  year
  total
  created_at
  updated_at
`
export const EMPLOYEE_DATA = `
  id
  name
  last_name
  fullName
  fullLastName
  document_type
  document_number
  is_active
  status_text
  assignment {
    headquarter_id
    headquarter {
      id
      name
    }
    work_type
    work_category
    condition
    area_id
    area {
      id
      name
    }
    sub_area_id
    sub_area {
      id
      name
    }
    position_id
    position {
      id
      name
    }
  }
  insurance {
    cussp
    afp_id
    afp {
      id
      name
    }
    type_regime
  }
  finance {
    base_salary
    family_allowance
  }
`

export const MONTHLY_PAYROLL_ITEM = `
  absence
  workedDays
  suspension
  ordinaryHours
  ordinaryMinutes
  hourExtra25_35
  minutesExtra
  jornaleBasic
  pieceworkBasic
  refreshment
  total_extra_25
  total_extra_35
  dobles
  family_allowance
  absence_discount
  loan_total
  total_income
  contribution
  insurance_premium
  flow
  mixed
  total_discount
  total_to_pay
  permissions {
    reason_permission_id
    days
  }
  bonds {
    bond_type_id
    amount
  }
  advances {
    advance_type_id
    amount
  }
  descuentosa {
    advance_type_id
    amount
  }
  discounts {
    discount_type_id
    type
    amount
  }
  rem_vacacional
  feriado_descanso
  importes_goce
  importe_domingos
  quincena1
  quincena2
  vacations_d
  vacations_t
  cts
  liquidacion 
  prestamos
  prestamototal
  retencionp
  adelantos
  subsidiados
  singoce
  diferencia
  segregular
  eps675
  eps225
  sctr_salud
  sctr_pension
  seguro_vida_ley
  utilidades
  fiestas_patrias
  gp_ley_29351
  bet_ley_29351
  importedomingos
  bep_ley_29351
  cts_904
  incapacidadtemporal
  maternidad
  sumagraciosa
  canasta
  totalmes
`
